import React from "react"
import { Link } from "gatsby"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div className="site-footer__bottom">
      <div className="container">
        <p>
          @ All copyright {currentYear}{" "}
          <a href="https://find-my-beach.com">Find My Beach</a> |{" "}
          <Link to="/privacy-policy">Privacy policy</Link>
        </p>
        <div className="site-footer__social">
          <a
            href="https://www.facebook.com/Find-My-Beach-110276687409669"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-facebook-square"></i>
          </a>
          <a
            href="https://www.instagram.com/find.my.beach/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="mailto:info@find-my-beach.com"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa fa-envelope"></i>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
